import { ChangeDetectorRef, Component, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { StartOrderService } from '../../custom-start-order/start-order.service';
import { ContentService } from '../../spartacus/services/content.service';
import { Observable } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent } from '@spartacus/core';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';

@Component({
  selector: 'app-reviewpage',
  templateUrl: './reviewpage.component.html',
  styleUrl: './reviewpage.component.scss',
  standalone: false
})
export class ReviewpageComponent {
  showCalendar = false;
  selectedDate: Date | undefined;
  dateformat:string=''
  // Configurable minimum date
  minDate = new Date('2026-08-03');
  // Today
  maxDate = new Date();
  currentMonth!: number;
  currentYear!: number;
  calendarDays: any[] = [];
  weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  monthNames = [
    'January', 'February', 'March',
    'April', 'May', 'June',
    'July', 'August', 'September',
    'October', 'November', 'December'
  ];
  seasonValue = '';
  enableSaveOrder: boolean = false;
  aqivCost: any = 0;
  qivcCost: any = 0;
  reviewPageData: any
  checkbox: boolean = false;
  enablePage: any
  isLoading: boolean = false;
  isAsAgent: boolean = false;
  totalCost: any = 0;
  isamendFlow: boolean = false;
  isConfirmOrder: boolean = false;
  aqiv: any;
  qivc: any;
  maxDeliverySlots: number = 4;
  deliverySlotArray: any;
  inseason: string = '';
  preseason: string = '';
  prepreseason: string = '';
  landingapi: any;
  reviewdelivery: any;
  isAllFieldsValid: boolean = false;
  isChecked = false;
  materialcheck = false;
  received: string = '';
  receivedOptions: string[] = [];
  date: string = '';
  dateerror: string = '';
  nameasmerror: string = '';
  receivederror:string='';
  nameasm: string = '';
  inseasondate: string = ''
  reviewcontent: any;
  reviewtext: Observable<any> = this.component.data$;
  isAllChecked: boolean = false;
  shippingData: any;
  constructor(private dialogservice: ApiFailureDialogService, public component: CmsComponentData<CmsBannerComponent>, private cdr: ChangeDetectorRef, private el: ElementRef, private userInfoService: UserInfoService, private startOrderService: StartOrderService, private contentservice: ContentService) {

  }
  ngOnInit() {
    const today = new Date();
this.currentMonth = today.getMonth();
this.currentYear = today.getFullYear();
this.generateCalendar();
    // Configure minimum date

    this.reviewtext.subscribe((res: any) => {
      this.reviewcontent = res;
      this.cdr.detectChanges();
    });
    this.contentservice.startapi().subscribe(data => {
      this.landingapi = data;
      this.inseason = this.landingapi?.currentInSeason;
      this.preseason = this.landingapi?.preSeason;
      this.prepreseason = this.landingapi?.prePreSeason
      this.cdr.detectChanges();
    });
    this.userInfoService.getstartorderseason().subscribe(
      (seasonValue: any) => {
        this.seasonValue = seasonValue;

        this.reviewdelivery = this.seasonValue?.split("-")[0];

        this.userInfoService.getEnablePage().subscribe(
          (data: any) => {
            this.enablePage = data;

            if (this.enablePage.showReviewPage) {
              this.isLoading = true;
              this.scrollToTop();

              this.startOrderService.getProductData().subscribe(
                (data: any) => {

                  if (data?.errorCode == "500" && localStorage.getItem('FailureDailog') != 'true') {
                    this.dialogservice.openErrorDialog();
                    localStorage.setItem('FailureDailog', 'true');
                    this.isLoading = false;
                    this.cdr.detectChanges();
                  }
                  if (data && this.enablePage.showReviewPage) {
                    this.reviewPageData = data;
                    const parts: string[] = this.reviewPageData.inseasonStartDate.split('-');

// Rearrange into YYYY-MM-DD (Note: change '06' and '12' to your target values or variables)
const formattedDate: string = `${parts[2]}-${parts[1]}-${parts[0]}`;
                    this.minDate= new Date(formattedDate)
                    this.generateCalendar();
                    this.materialcheck = this.reviewPageData?.isMaterialsConsentGiven;
                    this.shippingData = this.reviewPageData?.shippingData;
                    this.maxDeliverySlots = (this.reviewPageData?.constraintList?.maxDeliverySlots) - 1;
                    this.deliverySlotArray = this.reviewPageData.reviewData.cartEntries[0].products[0].deliverySlots
                      ? this.reviewPageData.reviewData.cartEntries[0].products[0].deliverySlots
                      : this.reviewPageData.reviewData.cartEntries[0].products[1].deliverySlots;

                    this.constructReviewDataSource();
                    this.startOrderService.setProductData(null);
                    this.isLoading = false;
                    this.cdr.detectChanges();
                  }
                },
                (error) => {
                  console.error('Error fetching product data:', error);
                  this.isLoading = false;
                  this.cdr.detectChanges();
                }
              );
            }
          },
          (error) => {
            console.error('Error fetching enable page:', error);
            this.isLoading = false;
            this.cdr.detectChanges();
          }
        );
      },
      (error) => {
        console.error('Error fetching start order season:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
    this.isAsAgent = this.userInfoService.checkAsmUser();
  }
  checkForErrrors() {
    const licCheckbox = this.el.nativeElement.querySelectorAll('.licenceCheckbox');
    this.isAllChecked = Array.from(licCheckbox).every((checkbox: any) => checkbox.checked);
    const hasErrorFields = this.el.nativeElement.querySelectorAll('.has-error');
    this.isAllFieldsValid = hasErrorFields.length === 0 && this.isAllChecked;
    this.cdr.detectChanges();
  }
  numberWithCommas(number: number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  asminputcheck(value:any,field:string){
    if (field == 'asmname') {
      var letters = /^[A-Za-z ]+$/;
      this.nameasmerror = (!value || value == '' ? 'Please enter a customer name' : (value.match(letters) ? '' : 'Please enter only letters'));
    }else if(field == 'date'){
      this.dateerror = (!value || value == '' ? 'Please enter a valid date' : '');

    }else if(field == 'received'){
      this.receivederror = (!value || value == '' ? 'Please select the checkbox' : '');

    }

    
  }
  handleOnInputValueChange(value: any, field: string, index: number) {
    if (field == 'firstName') {
      var letters = /^[A-Za-z ]+$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.firstNameErrorMsg = (!value || value == '' ? 'Please enter a first name' : (value.match(letters) ? '' : 'Please enter only letters'));
    } else if (field == 'email') {
      var letters = /^(?=(.{1,64}@.{1,255}))([!#$%&'*+\-\/=?\^_`{|}~a-zA-Z0-9}]{1,64}(\.[!#$%&'*+\-\/=?\^_`{|}~a-zA-Z0-9]{0,}){0,})@((\[(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}\])|([a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{2,63}){1,}))$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.emailErrorMsg = (!value || value == '' ? 'Please enter a valid email address.' : (value.match(letters) ? '' : 'Please enter a valid email address.'));
    } else if (field == 'phone') {
      var letters = /^[0-9]{10,11}$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.phoneNumberErrorMsg = (!value || value == '' ? 'Please enter a valid UK format phone number.' : (value.match(letters) ? value.length > 11 ? 'Please enter no more than 11 characters.' : '' : 'Please enter only Numbers.'));
    } else if (field == 'ext') {
      var letters = /^[0-9]+$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.phoneextErrorMsg = (value != '' ? (value.match(letters) ? '' : 'Please enter only Numbers.') : '');
    }
    else if (field == 'licenseInfoName') {
      var letters = /^[A-Za-z ]+$/;
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.nameErrorMsg = (!value || value == '' ? 'Please enter a licence name.' : (value.match(letters) ? '' : 'Please enter only letters.'));
      this.licencechange(index);
    } else if (field == 'licenseInfoNumber') {
      var letters = /^[A-Za-z0-9]+$/;
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.numberErrorMsg = (!value || value == '' ? 'Please enter a valid licence number.' : (value.match(letters) ? '' : 'Please enter only Letters and Numbers'));
      this.licencechange(index);
    } else if (field == 'checkbox') {
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checked = value;
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checkboxErrorMsg = this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checked ? '' : 'Please select the checkbox';
    } else if (field == 'commonCheckbox') {
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checkboxErrorMsg = this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checked ? '' : 'Please select the checkbox';
    } else if (field == 'nhs') {
      if (this.reviewPageData.reviewData.businessType == 'GP Medical Practice') {
        const regex = /^[A-Za-z]{1}[0-9]{5}$/;
        this.reviewPageData.reviewData.cartEntries[index].nhsErrorMsg = (value != '' ? (value.match(regex) ? '' : 'Please provide a valid NHS code e.g. Y02906') : '');
      }
      if (this.reviewPageData.reviewData.businessType == 'Pharmacy') {
        const regex = /^[F|f]([A-Za-z]|[0-9]){4}$/;
        this.reviewPageData.reviewData.cartEntries[index].nhsErrorMsg = (value != '' ? (value.match(regex) ? '' : 'Please provide a valid NHS code e.g. F1J4D') : '');
      }
      if (this.reviewPageData.reviewData.businessType == "Hospital - Public" || this.reviewPageData.reviewData.businessType == "Hospital - Private" || this.reviewPageData.reviewData.businessType == "Nursing Homes" || this.reviewPageData.reviewData.businessType == "Correctional Facility" || this.reviewPageData.reviewData.businessType == "Wholesaler") {
        const regex = /^.{6,6}$/;
        this.reviewPageData.reviewData.cartEntries[index].nhsErrorMsg = (value != '' ? (value.match(regex) ? '' : 'Please provide a valid NHS code') : '');
      }
    }
  }
  licencechange(index: number) {
    if (this.reviewPageData.reviewData.cartEntries[index].licenseInfo.nameErrorMsg != '' || this.reviewPageData.reviewData.cartEntries[index].licenseInfo.numberErrorMsg != '') {
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checked = false;
      this.cdr.detectChanges()
    }

  }
  handlepreprebookvalidation(event: any) {

    this.reviewPageData.reviewData.cartEntries.forEach((entry: any, index: number) => {
      this.handleOnInputValueChange(entry.deliveryContact.name, 'firstName', index);
      this.handleOnInputValueChange(entry.deliveryContact.email, 'email', index);
      this.handleOnInputValueChange(entry.deliveryContact.phone, 'phone', index);
      this.handleOnInputValueChange(entry.licenseInfo.name, 'licenseInfoName', index);
      this.handleOnInputValueChange(entry.licenseInfo.number, 'licenseInfoNumber', index);
      this.handleOnInputValueChange(entry.licenseInfo.checked, 'commonCheckbox', index);
      if (entry.deliveryContact.firstNameErrorMsg != '' || entry.deliveryContact.emailErrorMsg != '' || entry.deliveryContact.phoneNumberErrorMsg != '' || entry.deliveryContact.phoneextErrorMsg != '' || entry.licenseInfo.nameErrorMsg != '' || entry.licenseInfo.numberErrorMsg != '' || entry.licenseInfo.checkboxErrorMsg != '') {
        this.isAllFieldsValid = false
        event.preventDefault();
      } else {
        this.isAllFieldsValid = true;

      }
    })

    this.cdr.detectChanges();
  }
  handleOnCommonCheckboxvalueChange(event: any) {
    let array: any = [];
    this.reviewPageData.reviewData.cartEntries.forEach((entry: any, index: number) => {
      this.handleOnInputValueChange(entry.deliveryContact.name, 'firstName', index);
      this.handleOnInputValueChange(entry.deliveryContact.email, 'email', index);
      this.handleOnInputValueChange(entry.deliveryContact.phone, 'phone', index);
      this.handleOnInputValueChange(entry.licenseInfo.name, 'licenseInfoName', index);
      this.handleOnInputValueChange(entry.licenseInfo.number, 'licenseInfoNumber', index);
      this.handleOnInputValueChange(entry.licenseInfo.checked, 'commonCheckbox', index);

      if (entry.deliveryContact.firstNameErrorMsg != '' || entry.deliveryContact.emailErrorMsg != '' || entry.deliveryContact.phoneNumberErrorMsg != '' || entry.deliveryContact.phoneextErrorMsg != '' || entry.licenseInfo.nameErrorMsg != '' || entry.licenseInfo.numberErrorMsg != '' || entry.licenseInfo.checkboxErrorMsg != '') {
        array.push(false);
        event.preventDefault();
      } else {
        array.push(true);
      }
    })
    this.checkbox = array.every((val: any) => val == true);
    if (!this.checkbox) {
      event.preventDefault();
    }
    if (this.checkbox && !this.enableSaveOrder && this.seasonValue == '2025-2026') {
      this.enableSaveOrder = true;
    }
    this.cdr.detectChanges();
  }
  asmhandleOnCommonCheckboxvalueChange(event: any) {
    let array: any = [];
    this.reviewPageData.reviewData.cartEntries.forEach((entry: any, index: number) => {
      this.handleOnInputValueChange(entry.deliveryContact.name, 'firstName', index);
      this.handleOnInputValueChange(entry.deliveryContact.email, 'email', index);
      this.handleOnInputValueChange(entry.deliveryContact.phone, 'phone', index);
      this.handleOnInputValueChange(entry.licenseInfo.name, 'licenseInfoName', index);
      this.handleOnInputValueChange(entry.licenseInfo.number, 'licenseInfoNumber', index);
      this.handleOnInputValueChange(entry.licenseInfo.checked, 'commonCheckbox', index);
      this.asminputcheck(this.selectedDate,'date');
      this.asminputcheck(this.nameasm,'asmname');
      this.asminputcheck(this.received,'received');
      
      if (entry.deliveryContact.firstNameErrorMsg != '' || entry.deliveryContact.emailErrorMsg != '' || entry.deliveryContact.phoneNumberErrorMsg != '' || entry.deliveryContact.phoneextErrorMsg != '' || entry.licenseInfo.nameErrorMsg != '' || entry.licenseInfo.numberErrorMsg != '' || entry.licenseInfo.checkboxErrorMsg != '' || this.nameasmerror != '' ||this.dateerror!='' ||this.receivederror!='') {
        array.push(false);
        event.preventDefault();
      } else {
        array.push(true);
      }
    })
    this.checkbox = array.every((val: any) => val == true);
    if (!this.checkbox) {
      event.preventDefault();
    }
    if (this.checkbox && !this.enableSaveOrder && this.seasonValue == '2025-2026') {
      this.enableSaveOrder = true;
    }
    this.cdr.detectChanges();
  }
  locationlevelcheck(event: any, locationvalue: number) {
    this.handleOnInputValueChange(this.reviewPageData.reviewData.cartEntries[locationvalue].licenseInfo.name, 'licenseInfoName', locationvalue);
    this.handleOnInputValueChange(this.reviewPageData.reviewData.cartEntries[locationvalue].licenseInfo.number, 'licenseInfoNumber', locationvalue);
    if (this.reviewPageData.reviewData.cartEntries[locationvalue].licenseInfo.nameErrorMsg != '' || this.reviewPageData.reviewData.cartEntries[locationvalue].licenseInfo.numberErrorMsg != '') {
      event.preventDefault();
    }
  }

  validateForm(locationvalue: number) {

    this.handleOnInputValueChange(this.reviewPageData.reviewData.cartEntries[locationvalue].deliveryContact.name, 'firstName', locationvalue);
    this.handleOnInputValueChange(this.reviewPageData.reviewData.cartEntries[locationvalue].deliveryContact.email, 'email', locationvalue);
    this.handleOnInputValueChange(this.reviewPageData.reviewData.cartEntries[locationvalue].deliveryContact.phone, 'phone', locationvalue);


    this.handleOnInputValueChange(this.reviewPageData.reviewData.cartEntries[locationvalue].licenseInfo.name, 'licenseInfoName', locationvalue);
    this.handleOnInputValueChange(this.reviewPageData.reviewData.cartEntries[locationvalue].licenseInfo.number, 'licenseInfoNumber', locationvalue);
  }
  handleOnOrderClick(value: string) {
    this.userInfoService.setInPlaceOrder(false);
    this.isLoading = true;
    this.isConfirmOrder = (value == 'confirmOrder');
    let cartEntries: any = [];
    this.inseasondate = "12/07/2026"
    this.reviewPageData.reviewData.cartEntries.forEach((entry: any) => {
      const obj: any = {

        requestType: this.reviewPageData.priceResponse.requestType,
        sor: this.reviewPageData.priceResponse.SOR,
        creditDays: this.reviewPageData.priceResponse.creditDays,
        poNumber: entry.poNumber,
        // totalQty: 0, wt value to map
        // "orderID": "", //no label
        orderStatus: entry.orderStatus,
        qty50to64y: entry.qty50to64y,
        nhsCode: entry.nhsCode,
        orderModifiedAttribures: "",
        season: this.reviewPageData.selectedSeason,
        shippinglocID: entry.shippinglocID,
        products: entry.products,
        licenseInfo: entry.licenseInfo,
        deliveryContact: entry.deliveryContact
      }
      cartEntries.push(obj)
    })
    let payload:any
    if(this.isAsAgent){
       payload = {
        
        priceResponse: this.reviewPageData.priceResponse,
        saveOrderClosed: this.reviewPageData.saveOrderClosed,
        selectedSeason: this.reviewPageData.selectedSeason,
        confirmedOrder: this.reviewPageData.confirmedOrder,
        isMaterialsConsentGiven: this.materialcheck,
        orderType: value,
        reviewData: {
          businessType: this.reviewPageData.reviewData.businessType,
          soldToID: this.reviewPageData.reviewData.soldToID,          
          dateRequestReceived:this.dateformat,
          receivedRequestVia:this.received,
          receiverName:this.nameasm,
          salesContact: this.reviewPageData.reviewData.salesContact,
          cartEntries: cartEntries
        }
      };

    }else{
 payload = {
      priceResponse: this.reviewPageData.priceResponse,
      saveOrderClosed: this.reviewPageData.saveOrderClosed,
      selectedSeason: this.reviewPageData.selectedSeason,
      confirmedOrder: this.reviewPageData.confirmedOrder,
      isMaterialsConsentGiven: this.materialcheck,
      orderType: value,
      reviewData: {
        businessType: this.reviewPageData.reviewData.businessType,
        soldToID: this.reviewPageData.reviewData.soldToID,
        salesContact: this.reviewPageData.reviewData.salesContact,
        cartEntries: cartEntries
      }
    };
  }
    this.startOrderService.placeOrder(payload).subscribe((data: any) => {
      this.isLoading = false;
      if (data == 'success') {
        if (this.isConfirmOrder) {
          if (this.seasonValue == this.inseason) {
            const obj = {
              showLandingPage: false,
              showLocationPage: false,
              showProductPage: false,
              isProductBackBtnClicked: false,
              showReviewPage: false,
              showSaveThankYouPage: !this.isConfirmOrder,
              showinseasonConfirmThankYouPage: this.isConfirmOrder
            }
            this.userInfoService.setEnablePage(obj);
          } else {
            const obj = {
              showLandingPage: false,
              showLocationPage: false,
              showProductPage: false,
              isProductBackBtnClicked: false,
              showReviewPage: false,
              showSaveThankYouPage: !this.isConfirmOrder,
              showConfirmThankYouPage: this.isConfirmOrder
            }
            this.userInfoService.setEnablePage(obj);
          }

          this.scrollToTop();
          this.cdr.detectChanges();
        } else {
          const obj = {
            showLandingPage: false,
            showLocationPage: false,
            showProductPage: false,
            isProductBackBtnClicked: false,
            showReviewPage: false,
            showConfirmThankYouPage: false,
            showSaveThankYouPage: true,
            showSorryPage: false
          }
          this.userInfoService.setEnablePage(obj);
          this.cdr.detectChanges();
          this.scrollToTop();
        }
      } else {
        const obj = {
          showLandingPage: false,
          showLocationPage: false,
          showProductPage: false,
          isProductBackBtnClicked: false,
          showReviewPage: false,
          showConfirmThankYouPage: false,
          showSaveThankYouPage: false,
          showSorryPage: true
        }
        this.userInfoService.setInPlaceOrder(false);
        this.userInfoService.setEnablePage(obj);
        this.cdr.detectChanges();
        this.scrollToTop();
      }
    }, (error) => {
      console.log('error: ', error);
      this.isLoading = false;
      const obj = {
        showLandingPage: false,
        showLocationPage: false,
        showProductPage: false,
        isProductBackBtnClicked: false,
        showReviewPage: false,
        showConfirmThankYouPage: false,
        showSaveThankYouPage: false,
        showSorryPage: true
      }
      this.userInfoService.setInPlaceOrder(false);
      this.startOrderService.setApiFailurePopup(true);
      this.userInfoService.setEnablePage(obj);
      this.scrollToTop();
      this.cdr.detectChanges();
    })
  }
  checkboxtoggle(value: string) {
    const index = this.receivedOptions.indexOf(value);
    //below iam checking of -1 ,because if the valuse is not present it will return -1 otherwise returns the index value
    // if the valuue is already present then we are remoning
    if (index > -1) {
      this.receivedOptions.splice(index, 1);
    } 
    //if the value is not present then we are adding it to the array
    else {
      this.receivedOptions.push(value);
    }
    this.received = this.receivedOptions.join(',');
    this.cdr.detectChanges();
  }
  isReceivedSelected(value: string): boolean {
    return this.receivedOptions.indexOf(value) > -1;
  }
  handleOnBackBtnClick() {
    const obj = {
      showLandingPage: false,
      showLocationPage: false,
      showProductPage: false,
      isProductBackBtnClicked: false,
      showReviewPage: false,
      showConfirmThankYouPage: false,
      showSaveThankYouPage: false,
      isDeliveryBackBtnClicked: true
    }
    this.userInfoService.setEnablePage(obj);
    this.scrollToTop();
  }

  constructReviewDataSource() {
    let aqiv: any = [];
    let qivc: any = [];
    let totalProductCost: any = [];
    this.reviewPageData.reviewData.cartEntries.forEach((entry: any) => {
      entry.deliveryContact['firstNameErrorMsg'] = '';
      entry.deliveryContact['emailErrorMsg'] = '';
      entry.deliveryContact['phoneNumberErrorMsg'] = '';
      entry.deliveryContact['phoneextErrorMsg'] = '';
      entry.licenseInfo['nameErrorMsg'] = '';
      entry.licenseInfo['numberErrorMsg'] = '';
      entry.licenseInfo['checkboxErrorMsg'] = '';
      entry.licenseInfo['checked'] = false;
      entry['nhsCode'] = '';
      entry['nhsErrorMsg'] = '';
      entry['poNumber'] = '';
      const filterLocation = this.reviewPageData.shippingData.filter((location: any) => { return entry.shippinglocID == location.locID });
      entry['address'] = filterLocation[0].address;
      entry['locname'] = filterLocation[0].locname;
      entry['state'] = filterLocation[0].state;
      let sumSaleProduct: any = [];
      let productArray: any = [];
      if (entry.products.length == 1) {
        this.reviewPageData.productList.forEach((el: any) => {
          if (el.code != entry.products[0].materialID) {
            const obj = {
              materialID: el.code.toString(),
              qty: 0,
            }
            productArray.push(obj);
          } else {
            productArray.push(entry.products[0])
          }
        })
        entry.products = productArray;
      }
      entry.products.forEach((product: any, index: number) => {
        const filterProduct = this.reviewPageData.productList.filter((prodList: any) => { return product.materialID == prodList.code });
        const filterMaterial = this.reviewPageData.priceResponse.materials.filter((material: any) => { return product.materialID == material.materialID });
        product['baseName'] = filterProduct[0].baseName;
        const value = product.qty == 0 ? 0 : product.qty * Number(filterMaterial[0].salePrice);
        sumSaleProduct.push(value);
        if (product.baseName == 'AQIV') {
          aqiv.push(product.qty);
        } else if (product.baseName == 'QIVC') {
          qivc.push(product.qty);
        }
        if (product.deliverySlots) {
          product.deliverySlots.forEach((value: any) => {
            if (!value.quantity) {
              value['quantity'] = 0;
            }
          })
        }
      })
      totalProductCost.push(parseFloat((sumSaleProduct.reduce((partialSum: number, value: number) => partialSum + value, 0)).toFixed(2)))
      entry['prodCost'] = this.numberWithCommas((sumSaleProduct.reduce((partialSum: number, value: number) => partialSum + value, 0)).toFixed(2));
      this.aqivCost = this.numberWithCommas((aqiv.reduce((partialSum: number, value: number) => partialSum + value, 0)));
      this.qivcCost = this.numberWithCommas((qivc.reduce((partialSum: number, value: number) => partialSum + value, 0)));
      this.totalCost = this.numberWithCommas((totalProductCost.reduce((partialSum: number, value: number) => partialSum + value, 0)).toFixed(2))
    })
  }
  toggleCalendar() {
    this.showCalendar = !this.showCalendar;
    }
    generateCalendar() {
    this.calendarDays = [];
    const firstDay =
    new Date(this.currentYear, this.currentMonth, 1)
    .getDay();
    const totalDays =
    new Date(this.currentYear, this.currentMonth + 1, 0)
    .getDate();
    // Empty cells
    for (let i = 0; i < firstDay; i++) {
    this.calendarDays.push(null);
    }
    for (let day = 1; day <= totalDays; day++) {
    const date =
    new Date(this.currentYear, this.currentMonth, day);
    const selectable = date >= this.minDate && date <= this.maxDate;
    this.calendarDays.push({
    day,
    date,
    selectable
    });
    }
    }
    previousMonth() {
    //here iam getting the last date of prev month and putting it ina avariable
    const prevMonthLastDate = new Date(this.currentYear,this.currentMonth,0);
    //if prev month last date is less than the min date do nothing, just return otherwise go the previous month
    if(prevMonthLastDate < this.minDate){
      return;
    }
    this.currentMonth--;
    if (this.currentMonth < 0) {
    this.currentMonth = 11;
    this.currentYear--;
    }
    this.generateCalendar();
    }
    isPrevDisabled(): boolean {
    const prevMonthLastDate = new Date(this.currentYear,this.currentMonth,0);
    return prevMonthLastDate < this.minDate;
    }
    nextMonth() {
    const nextDate = new Date(
    this.currentYear,
    this.currentMonth + 1,1
    );
    if (nextDate > this.maxDate) {
    return;
    }
    this.currentMonth++;
    if (this.currentMonth > 11) {
    this.currentMonth = 0;
    this.currentYear++;
    }
    this.generateCalendar();
    }
    isNextDisabled(): boolean {
    const nextDate = new Date(
    this.currentYear,
    this.currentMonth + 1,1
    );
    return nextDate > this.maxDate;
    }
    selectDate(day: any) {
    if (!day.selectable) {
    return;
    }
    this.selectedDate = day.date;
    this.showCalendar = false;
    this.dateformat=this.formatDate(day.date)
    this.asminputcheck(this.selectedDate,'date');
    this.checkForErrrors();
    console.log(this.dateformat);
    }
    formatDate(date: Date): string {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
    
    }
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent):void {
      const target = event.target as HTMLElement;
      const modal = this.el.nativeElement.querySelector('.calendar-popup');
      if (modal && !modal.contains(target)) {
        this.showCalendar = false;
        
      }
     
      
    }
    
    
}
